import { Inject } from '@odinjs/odin';

import { Endpoint, FOUNDATION_ROUTES, Route } from '@philips-emr/hpms-stipulator-commons';
import { HpmsTermServiceApi } from '@philips-emr/hpms-stipulator-components';
import { HPMSOnSubmitTermoUso } from '@philips-emr/hpms-stipulator-components/lib/events/event';
import { FetchAPI } from '@philips-emr/tws-components';
import Controller, { OnClose, OnMount } from '@philips-emr/tws-core/lib/client';
import { AuthenticationService, HttpService } from '@philips-emr/tws-core/lib/services';
import { applicationContext } from '@philips-emr/tws-foundation';

import BaseController from './BaseController';

interface TermoUso {
  nrSeqTermo: number;
  nrSeqTermoUso: number;
}

@Controller({ fragment: 'assign-termo-uso-modal', component: 'modal-assign-termo-uso' })
class AssignTermUsoModalController extends BaseController {

  @Inject('fetch-hpms-term-uso')
  private fetchTermoUso: FetchAPI;

  @Inject('hpms-term-service')
  private checkTerm: HpmsTermServiceApi;

  @OnMount({ target: ['modal-assign-termo-uso'] })
  onMount(): void {
    const { nrSeqTermo } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqTermo });
    const nrSeqValid = nrSeqTermo !== 'undefined';
    this.checkTerm.setEnabled(nrSeqValid);
    if (nrSeqValid) {
      this.fetchTermoUso.setParameters({ nrSeqTermo });
      this.fetchTermoUso.forceFetch();
    }
  }

  @OnClose({ target: ['modal-assign-termo-uso'] })
  onclose(): void {
    void AuthenticationService.logout().then(() => {
      this.historyService.push(FOUNDATION_ROUTES.LOGIN);
    });
  }

  @HPMSOnSubmitTermoUso('hpms-term-service')
  onSubmitTermoUso(): void {
    const { nrSeqTermo } = this.historyService.getCurrentRouteParams();
    if (nrSeqTermo !== 'undefined') {
      void HttpService.put(Endpoint.PUT.UPDATE_TERMOS_USO, { nrSeqTermo }).then(() => {
        void this.checkAvisoPrivacidade();
      });
    }
  }

  private async checkAvisoPrivacidade(): Promise<void> {

    await HttpService.get(Endpoint.GET.CHECK_AVISO_DE_PRIVACIDADE).then(async respCheckAviso => {
      const { nrSeqTermoUso } = respCheckAviso.body as TermoUso;
      if (!nrSeqTermoUso) {
        await HttpService.get(Endpoint.GET.AVISO_DE_PRIVACIDADE_ATUAL).then(respAviso => {
          const { nrSeqTermoUso } = respAviso.body as TermoUso;
          if (nrSeqTermoUso) {
            this.context.set({ nrSeqAviso: nrSeqTermoUso });
            this.historyService.push(Route.ASSIGN_AVISO_DE_PRIVACIDADE, { nrSeqAviso: nrSeqTermoUso });
          } else {
            applicationContext.openModule('inicio');
          }
        });
      } else {
        applicationContext.openModule('inicio');
      }
    });
  }

}

export default AssignTermUsoModalController;
